// extracted by mini-css-extract-plugin
export default {"answer":"FaqItems_answer__gsLco"};